import { PRIMARY_RED_01 } from 'bd-web-components/src/utils/dash-colors'
import styled, { css } from 'styled-components'

interface ExceptionContainerProps {
  height: number
  margin: boolean
}

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1325px;
  margin: 0 auto;
  margin-bottom: 162px;
  padding: 0px 64px;
  @media (max-width: 768px) {
    padding: 0px 24px;
  }
`

export const ExceptionContainer = styled(styled.div``) <ExceptionContainerProps>`
  display: flex;
  justify-content: center;
  align-items: center;

  ${(props) =>
    props.height !== undefined &&
    css`
      height: ${props.height}px;
    `}
  ${(props) =>
    props.margin &&
    css`
      margin-bottom: 100px;
    `}
`

// Header ---------------------------------------------------------

export const EventTitle = styled.h1`
  color: #0a0a0a;
  font-family: 'Barlow Condensed', 'Inter', sans-serif;
  font-size: 52px;
  font-weight: 900;
  letter-spacing: -0.52px;
  line-height: 0.94;
  text-transform: uppercase;
  margin-top: 20px;
  word-break: break-word;
  @media (max-width: 768px) {
    font-size: 38px;
  }
`

export const MetaRow = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
  margin-top: 16px;
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
`

export const MetaItem = styled.span`
  display: flex;
  align-items: center;
  gap: 7px;
  color: #737373;
  font-size: 14px;
  line-height: 20.3px;

  img {
    width: 16px;
    height: 16px;
  }
`

export const MetaDot = styled.span`
  width: 4px;
  height: 4px;
  border-radius: 9999px;
  background-color: #d4d4d4;
  @media (max-width: 768px) {
    display: none;
  }
`

export const HeaderDivider = styled.div`
  width: 100%;
  height: 1px;
  background-color: #e5e5e5;
  margin-top: 28px;
`

// Acesso rápido ---------------------------------------------------

export const QuickAccessSection = styled.section`
  margin-top: 32px;
`

export const QuickAccessLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  color: #737373;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.72px;
  text-transform: uppercase;

  img {
    width: 18px;
    height: 18px;
  }
`

export const QuickAccessButtons = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 14px;
`

export const QuickButton = styled.button<{ $primary?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 46px;
  padding: 0 20px;
  border-radius: 9999px;
  border: 1px solid #d4d4d4;
  background-color: #ffffff;
  color: #0a0a0a;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  cursor: pointer;
  transition: background-color 0.15s ease, filter 0.15s ease;

  &:hover {
    background-color: #fafafa;
  }

  ${(props) =>
    props.$primary &&
    css`
      border: none;
      background-color: ${PRIMARY_RED_01};
      color: #fafafa;

      &:hover {
        background-color: ${PRIMARY_RED_01};
        filter: brightness(0.92);
      }
    `}

  @media (max-width: 768px) {
    height: 40px;
    padding: 0 16px;
  }
`

export const QuickButtonIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;

  img {
    max-width: 16px;
    max-height: 16px;
  }
`

// Seções de opções -------------------------------------------------

export const Section = styled.section`
  margin-top: 36px;
`

export const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`

export const SectionTitle = styled.h2`
  color: #0a0a0a;
  font-size: 20px;
  font-weight: 700;
  letter-spacing: -0.2px;
  line-height: 30px;
`

export const SectionBadge = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 22px;
  height: 22px;
  padding: 0 7px;
  border-radius: 9999px;
  background-color: #f5f5f5;
  color: #737373;
  font-size: 12px;
  font-weight: 700;
`

export const SectionRule = styled.span`
  flex: 1;
  height: 1px;
  background-color: #e5e5e5;
`

export const CardsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  margin-top: 16px;
  @media (max-width: 1152px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`
